import { render, staticRenderFns } from "./DispatchNew.html?vue&type=template&id=1c578ece&scoped=true&external"
import script from "./DispatchNew.js?vue&type=script&lang=js&external"
export * from "./DispatchNew.js?vue&type=script&lang=js&external"
import style0 from "./DispatchNew.vue?vue&type=style&index=0&id=1c578ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c578ece",
  null
  
)

export default component.exports